import { memo, useMemo } from 'react';
import { DeviceMountEnum } from '@ubnt/link-core/enums';
import { useApplicationStore } from 'modules/application/store';
import ToggleButton from 'modules/bottomPanel/components/elements/ToggleButton';
import DeviceMountWallIcon from 'icons/DeviceMountWall.svg';
import DeviceMountCeilingIcon from 'icons/DeviceMountCeiling.svg';

type Mounts = typeof DeviceMountEnum.Wall | typeof DeviceMountEnum.Ceiling;

const MountIcons = {
  [DeviceMountEnum.Wall]: DeviceMountWallIcon,
  [DeviceMountEnum.Ceiling]: DeviceMountCeilingIcon,
};

const MountTooltipsDesktop = {
  [DeviceMountEnum.Ceiling]: 'Click to switch to Wall Mounted',
  [DeviceMountEnum.Wall]: 'Click to switch to Ceiling Mounted',
};

const MountTooltipsMobile = {
  [DeviceMountEnum.Wall]: 'Switched to Wall Mounted',
  [DeviceMountEnum.Ceiling]: 'Switched to Ceiling Mounted',
};

const MountTooltipsTitle = {
  [DeviceMountEnum.Wall]: 'Wall Mounted',
  [DeviceMountEnum.Ceiling]: 'Ceiling Mounted',
};

export interface MountSwitchProps {
  onClick: () => void;
  mount: Mounts;
}

const MountSwitch = (props: MountSwitchProps) => {
  const { onClick, mount } = props;
  const isMobile = useApplicationStore((state) => state.isMobile);
  const MountIcon = useMemo(() => MountIcons[mount], [mount]);
  const MountTooltips = isMobile ? MountTooltipsMobile : MountTooltipsDesktop;

  return (
    <ToggleButton onClick={onClick} tooltipDescription={MountTooltips[mount]} tooltipTitle={MountTooltipsTitle[mount]}>
      <MountIcon />
    </ToggleButton>
  );
};

const MemoizedMountSwitch = memo(MountSwitch);

export default MemoizedMountSwitch;
